var scrim = '_11lesip0';

export { scrim };
//# sourceMappingURL=popover-primitive.css.js.map
